import Axios from '@/Axios'

class GroupConfigurationService {
    async createGroupConfiguration(data) {
        return await Axios.post('wms.wms.api.group_configuration.create_new_configuration', data)
    }
    async updateGroupConfigurations(data) {
        return await Axios.put('wms.wms.api.group_configuration.update_group_configuration', data)
    }
    async updateGroupEmployeeAllocation(data) {
        return await Axios.put('wms.wms.api.group_configuration.update_employee_allocation', data)
    }
    async getGroupConfigurations(data) {
        return await Axios.get('wms.wms.api.group_configuration.get_group_configurations', {params : data})
    }
    async getAllGroupConfigurations(data) {
        return await Axios.get('wms.wms.api.group_configuration.get_all_group_configurations', {params : data})
    }
    async getGroupConfigurationById(groupName) {
        return await Axios.get('wms.wms.api.group_configuration.get_group_configuration_by_id', {params : {name : groupName}})
    }
    async deleteGroupConfiguration(data) {
        return await Axios.delete('wms.wms.api.group_configuration.delete_group_configurations', {data})
    }

    async getAssignmentConfigurations(data) {
        return await Axios.get('wms.wms.api.group_configuration.get_assignment_configurations', {params : data})
    }
    async updateAssignmentConfigurationSampling(data) {
        return await Axios.put('wms.wms.api.group_configuration.update_assignment_configuration_sampling', data)
    }
    async saveAssignmentConfigurationsfunctionality(data) {
        return await Axios.put('wms.wms.api.group_configuration.save_assignment_configuration_functionality', data)
    }
}
export default new GroupConfigurationService()
